import type { ProductOptionI18nFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";

export const serverModelToInputModelConverter = (
	serverModel: ServerModel,
): ProductOptionI18nFormModel["InputModel"] => {
	const { optionI18n } = serverModel;

	const inputModel: ProductOptionI18nFormModel["InputModel"] = {
		hotelID: optionI18n.hotelID,
		optionID: optionI18n.optionID,
		lang: optionI18n.lang,

		name: optionI18n.name,

		description: optionI18n.description,

		subOptions: optionI18n.subOptions,
	} satisfies ProductOptionI18nFormModel["InputModel"];
	return inputModel;
};
